import { useState, useEffect } from 'react';
import { apiGet, API_ENDPOINTS } from './apiUtils';

let userFeatures = [];

export const loadUserFeatures = async () => {
  try {
    const result = await apiGet(API_ENDPOINTS.FEATURES.MY_FEATURES);
    if (result.success) {
      userFeatures = result.data;
      return userFeatures;
    }
    return [];
  } catch (error) {
    console.error('Error loading user features:', error);
    return [];
  }
};

export const hasFeature = (featureName) => {
  return userFeatures.includes(featureName);
};

// Hook for React components
export const useFeature = (featureName) => {
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAccess = async () => {
      const features = await loadUserFeatures();
      setHasAccess(features.includes(featureName));
      setLoading(false);
    };

    checkAccess();
  }, [featureName]);

  return { hasAccess, loading };
};

// Higher Order Component for feature-based access control
export const withFeature = (featureName, FallbackComponent = null) => (WrappedComponent) => {
  return (props) => {
    const { hasAccess, loading } = useFeature(featureName);

    if (loading) {
      return <div>Loading...</div>;
    }


    if (!hasAccess) {
      return FallbackComponent ? <FallbackComponent /> : null;
    }


    return <WrappedComponent {...props} />;
  };
};
